/** Built-in role codes cloned per organization at signup. */
export const STANDARD_ROLE_CODES = [
  'ORGANIZATION_OWNER',
  'STORE_MANAGER',
  'CASHIER',
  'INVENTORY_MANAGER',
] as const;

export type StandardRoleCode = (typeof STANDARD_ROLE_CODES)[number];

export const ROLE_DESCRIPTIONS: Record<string, string> = {
  ORGANIZATION_OWNER:
    'Full access: settings, stores, employees, roles, products, inventory, billing, and reports.',
  STORE_MANAGER:
    'Store operations, billing, products, customers, and role configuration (not employee HR).',
  CASHIER: 'POS checkout, held bills, and customer lookup.',
  INVENTORY_MANAGER: 'Products, stock, suppliers, and inventory reports.',
};

export const ROLES_HELP = {
  title: 'Why roles?',
  body: 'Roles define what each staff member can do after they sign in. When you add an employee with an email and role, a login account is created automatically with that access.',
  owner:
    'As Organization Owner you assign roles on the Employees page. Use built-in roles for common jobs, or create custom roles here for fine-grained permissions.',
};

/** Permission codes for quick custom-role presets (matches built-in templates). */
export const ROLE_PRESET_PERMISSIONS: Record<string, string[]> = {
  CASHIER: [
    'PRODUCT_VIEW',
    'BILLING_VIEW',
    'BILLING_CREATE',
    'CUSTOMER_VIEW',
    'DASHBOARD_VIEW',
    'STORE_VIEW',
  ],
  STORE_MANAGER: [
    'ORG_VIEW',
    'STORE_VIEW',
    'STORE_MANAGE',
    'EMPLOYEE_VIEW',
    'PRODUCT_VIEW',
    'PRODUCT_MANAGE',
    'INVENTORY_VIEW',
    'INVENTORY_MANAGE',
    'BILLING_VIEW',
    'BILLING_CREATE',
    'BILLING_RETURN',
    'CUSTOMER_VIEW',
    'CUSTOMER_MANAGE',
    'REPORT_VIEW',
    'DASHBOARD_VIEW',
    'ROLE_VIEW',
    'ROLE_MANAGE',
  ],
  INVENTORY_MANAGER: [
    'PRODUCT_VIEW',
    'PRODUCT_MANAGE',
    'INVENTORY_VIEW',
    'INVENTORY_MANAGE',
    'REPORT_VIEW',
    'DASHBOARD_VIEW',
    'STORE_VIEW',
  ],
};

export const ROLE_PRESET_LABELS: { key: string; label: string; hint: string }[] = [
  { key: 'CASHIER', label: 'Cashier (POS)', hint: 'Checkout, customers, held bills' },
  { key: 'STORE_MANAGER', label: 'Store manager', hint: 'Store ops, billing, products, reports' },
  { key: 'INVENTORY_MANAGER', label: 'Inventory', hint: 'Stock, suppliers, products' },
];
